var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeetings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_7905_4934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16.3523 8.66218L15.4376 6.45335L16.667 4.99935L15.0003 3.33268L13.5542 4.56848L11.2985 3.6408L10.7798 1.66602H9.15114L8.62456 3.66695L6.42067 4.59598L5.00033 3.33268L3.33366 4.99935L4.5448 6.49006L3.64408 8.70462L1.66699 9.16602V10.8327L3.66792 11.3789L4.59678 13.5825L3.33366 14.9993L5.00033 16.666L6.49296 15.4496L8.6645 16.343L9.16699 18.3327H10.8337L11.3374 16.3437L13.5463 15.429C13.9144 15.6921 15.0003 16.666 15.0003 16.666L16.667 14.9993L15.4303 13.5405L16.3452 11.331L18.3336 10.8137L18.3337 9.16602L16.3523 8.66218Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7905_4934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeetings);
export default __webpack_public_path__ + "static/media/seetings.b0e950a0453ef203f8c60adabad4237b.svg";
export { ForwardRef as ReactComponent };